module.exports = __webpack_public_path__ + "static/media/1.7729e05a.png";